import React, {useEffect, useState} from "react";
import {Layout} from "antd";

import {Outlet} from "react-router-dom";
import Header from "./header/header";
import "./index.scss";
import Sider from "./sider/sider";
import {HeaderPage} from "components/common";

const MainLayout: React.FC = () => {
  const [siderMS, setSiderMS] = useState("khuc-xa");

  // useEffect(() => {
  // }, [siderMS]);

  return (
    <div className="dkk-main">
      <Layout style={{height: "100vh", display: "flex"}}>
        <Sider siderMenuSelected={siderMS} setSiderMS={setSiderMS}></Sider>

        <Layout>
          <Header headerMenu={undefined} />

          <div className="content">
            <HeaderPage></HeaderPage>
            <div className="out-let">
              <Outlet />
            </div>
          </div>
        </Layout>
      </Layout>
    </div>
  );
};

export default MainLayout;
